import React, { useEffect, useState, useContext } from 'react';
import ReactSpinkit from 'react-spinkit';
import { GlobalContext } from '../utils/GlobalContext';

const SpinnerComponent = () => {
  const { golbalClientDetails } = useContext(GlobalContext);
  const [colorCode, setColorCode] = useState([]);

  useEffect(() => {
    // Ensure golbalClientDetails is not null before attempting to access its properties
    if (golbalClientDetails) {
      let clientDetailsData = golbalClientDetails.client_id[0];
      
      if (clientDetailsData && clientDetailsData.color_code) {
        const parsedColorCodes = clientDetailsData.color_code.split(',');
        
        if (parsedColorCodes.length === 2) {
          setColorCode(parsedColorCodes);
        }
      }
    }
  }, [golbalClientDetails]); // Add golbalClientDetails as a dependency to rerun effect when it changes
  
  return (
    <>
      {/* Ensure that colorCode is an array and has a valid length before rendering */}
      {Array.isArray(colorCode) && colorCode.length > 0 ? (
        <div className="spinner-container">
          <ReactSpinkit name="line-spin-fade-loader" color={colorCode[0]} />
        </div>
      ) : (
        // Optionally, show a fallback or loading state
        <div className="spinner-container">
          <ReactSpinkit name="line-spin-fade-loader" color="blue" />
        </div>
      )}
    </>
  );
};

export default SpinnerComponent;
